// Native-language versions of the two English candidate pages that send most
// of the site's Just One Interview (JOI) sign-ups: /features/interview-warmup
// and /features/ai-video-interview. One template (app/native/candidate/page.jsx),
// one copy file per language in lib/native/candidate/<code>.js.
//
// A language becomes a route, a prerendered head, a sitemap entry and a
// language-bar target only when its copy file exists. Adding a language is one
// new file. Plain JS with no imports, so the app and the build scripts share it.
// The English master is lib/native/candidateEn.js (not rendered).

// JOI's language codes. The portal reads ?lang=<code> and switches its whole UI.
export const CANDIDATE_LANG_CODES = ["de", "fr", "es", "sv", "it", "ja", "fil", "th", "id"];
export const CANDIDATE_SLUGS = ["interview-warmup", "ai-video-interview"];

export const englishCandidatePath = (slug) => `/features/${slug}`;
export const nativeCandidatePath = (code, slug) => `/${code}/features/${slug}`;

// /es/features/interview-warmup -> { code: "es", slug: "interview-warmup" }
const PATH_RE = new RegExp(`^/(${CANDIDATE_LANG_CODES.join("|")})/features/(${CANDIDATE_SLUGS.join("|")})$`);
export function parseNativeCandidatePath(pathname) {
  const m = PATH_RE.exec(String(pathname || "").replace(/\/+$/, ""));
  return m ? { code: m[1], slug: m[2] } : null;
}

// Browser language tag to a JOI code. Filipino shows up as tl or fil, Indonesian
// as id or the old in.
const BROWSER_TO_CODE = { tl: "fil", in: "id" };
export function candidateCodeForBrowser(languages) {
  for (const tag of languages || []) {
    const base = String(tag || "").toLowerCase().split("-")[0];
    if (base === "en") return null;
    const code = BROWSER_TO_CODE[base] || base;
    if (CANDIDATE_LANG_CODES.includes(code)) return code;
  }
  return null;
}

// The hreflang cluster of one slug: English, every native version that exists,
// x-default on the English page. `metas` are the language files' `meta` objects.
// Filipino carries hreflang "tl", as JOI does (meta.hreflang).
export function candidateHreflangLinks(slug, metas, siteUrl) {
  return [
    `<link rel="alternate" hreflang="en" href="${siteUrl}${englishCandidatePath(slug)}" />`,
    ...metas.map((m) => `<link rel="alternate" hreflang="${m.hreflang}" href="${siteUrl}${nativeCandidatePath(m.code, slug)}" />`),
    `<link rel="alternate" hreflang="x-default" href="${siteUrl}${englishCandidatePath(slug)}" />`,
  ];
}
